import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import NoFiberLead from '../Partials/NoFiberLead/NoFiberLead';
import LegacyLeadPage from './LegacyLeadPage';
import EpiContext from '@episerver/spa-core/Spa';
import { reportDWH, reportAnalytics } from '../saleJetBlockSlice';
import { createLead } from '../saleBlockAsyncThunk';
import { gtag4 } from '../../../../utilities/analytics/tracking';

const reportInternetNoSivimAnalytics = (action, label) => ({
  eventCategory: 'sivim_process',
  eventAction: action,
  eventLabel: label,
});

const FiberNoFiberLeadPage = (props) => {
  useEffect(() => {
    props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'No Fiber- Lead Page Display' });
    gtag4({
      event: `${props.saleType}_Step3_LeadPage`,
      step: '3',
      action: 'LeadPage',
      funnel_name: 'No_Sivim',
    });
    const analytics = reportInternetNoSivimAnalytics('address_without_sivim', 'address_without_sivim');
    props.reportAnalytics(analytics);
  }, []);

  async function handleFinish() {
    props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'No Fiber - Finish Button Clicked' });
    gtag4({
      event: `${props.saleType}_Step3_LeadFormButton`,
      button: 'סיום',
      action: 'LeadFormButton',
      funnel_name: 'No_Sivim',
    });
    const createLeadResult = await props.createLead();
    if (createLeadResult?.payload?.Body?.isSuccess) {
      gtag4({
        event: `${props.saleType}_Step5_LeadSent`,
        step: '5',
        action: 'LeadSent',
        funnel_name: 'No_Sivim',
      });
      props.reportAnalytics(reportInternetNoSivimAnalytics('lead_submit', 'lead_submit'));
      props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'No Fiber - Sent Lead Form' });
      EpiContext.navigateTo(EpiContext.getSpaBasePath());
    }
  }

  return (
    <div className='slideAnimation'>
      <div className='sale-page-content full-width no-fiber-lead-page'>
        <NoFiberLead subtitle={props.noFiberLeadSubtitle} />
        <SaleFooter
          isDisplayFooter={true}
          btnText='סיום'
          onclick={handleFinish}
          formid='saleJet'
          isWhiteButton={true}
          className='cancelFixed'
        />
      </div>
    </div>
  );
};

const LeadPage = (props) => {
  const isInternetNoFiberLead = props.leadType === 'noFiber' && props.saleType === 'internet';

  if (!isInternetNoFiberLead) {
    return <LegacyLeadPage />;
  }

  return <FiberNoFiberLeadPage {...props} />;
};

const mapStateToProps = (state) => ({
  saleType: state.saleJetBlock.saleType,
  leadType: state.saleJetBlock.leadType,
  noFiberLeadSubtitle: state.saleJetBlock.saleBlockData.noFiberLeadSubtitle,
});

const mapDispatchToProps = {
  reportDWH,
  createLead,
  reportAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadPage);
